import React from "react";

export const Github = () => {
  const colourTheme = {
    background: "transparent",
    text: "#ffffff",
    grade4: "#8400b8",
    grade3: "#b22ff4",
    grade2: "#b265f6",
    grade1: "#c084f5",
    grade0: "#ecd9fc"
  };


  return (
    <>
      <div className={"section " + colourTheme} data-aos="fade-right">
        
      </div>
    </>
  );
};
